// extracted by mini-css-extract-plugin
export default {"grid":"ImageGrid_grid__yCVqh","lastRowSpacer":"ImageGrid_lastRowSpacer__vE0OJ"};